/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCurrencyFrank = createReactComponent("currency-frank", "IconCurrencyFrank", [
  ["path", { d: "M17 5h-6a2 2 0 0 0 -2 2v12", key: "svg-0" }],
  ["path", { d: "M7 15h4", key: "svg-1" }],
  ["path", { d: "M9 11h7", key: "svg-2" }]
]);

export { IconCurrencyFrank as default };
//# sourceMappingURL=IconCurrencyFrank.js.map
